import request from "../Config/axios";
// -----------------------------------------------------------
export const GetAll_Paging_Food_Api = async (params) => {
    const { data } = await request.post(
        `/Food/GetAll_Paging`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_Food_Api = async (params) => {
    const { data } = await request.post(
        `/Food/GetAll`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Add_Food_Api = async (params) => {
    const { data } = await request.post(
        `/Food/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetById_Food_Api = async (id) => {
    const { data } = await request.get(
        `/Food/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const Update_Food_Api = async (params) => {
    const { data } = await request.post(
        `/Food/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_Food_Api = async (id) => {
    const { data } = await request.delete(
        `/Food/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
